import {
  cloneElement,
  ForwardedRef,
  forwardRef,
  isValidElement,
  ReactNode,
} from "react";
import { AddIcon } from "@chakra-ui/icons";
import {
  Button,
  ButtonProps,
  IconButton,
  IconButtonProps,
} from "@chakra-ui/react";
import { DropDownButtonIcon } from "components/Shared/DropDownMenu";

type Props = ButtonProps;

const DEFAULT_LABEL = "Create";

function CreateButtonInner(
  {
    children: childrenProp = DEFAULT_LABEL,
    colorScheme = "pinkButton",
    leftIcon = <AddIcon boxSize=".7em" />,
    size = "xs",
    ...rest
  }: Props,
  ref: ForwardedRef<HTMLButtonElement>,
) {
  // MenuButton wraps children in a span...this lets us populate that element's
  // children with our default if undefined.
  const children =
    childrenProp &&
    isValidElement<{ children?: ReactNode }>(childrenProp) &&
    childrenProp.props.children === undefined
      ? cloneElement(childrenProp, undefined, DEFAULT_LABEL)
      : childrenProp;
  return (
    <Button {...{ ref, colorScheme, leftIcon, size }} {...rest}>
      {children}
    </Button>
  );
}

export default forwardRef(CreateButtonInner);

type DropDownButtonProps = Partial<IconButtonProps>;

function CreateButtonDropDownButtonInner(
  props: DropDownButtonProps,
  ref: ForwardedRef<HTMLButtonElement>,
) {
  return (
    <IconButton
      ref={ref}
      aria-label="Open Menu"
      colorScheme="pinkButton"
      icon={<DropDownButtonIcon />}
      pl={1}
      pr={2}
      borderLeftWidth={1}
      {...props}
    />
  );
}

export const CreateButtonDropDownButton = forwardRef(
  CreateButtonDropDownButtonInner,
);
